import { CLOSE_PROFFIT_SEARCH_HEADER_SHARE_MODAL } from '../actions/ProffitSearchHeaderAction';
const INITIAL_STATE = {
    isHeaderShareModalClosed: false,
};
/**
 * ヘッダーの案件共有モーダルを閉じたかどうかを制御するreducer
 * @param state
 * @param type
 * @returns {{isHeaderShareModalClosed: boolean}}
 */
// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, { type }) => {
    switch (type) {
        case CLOSE_PROFFIT_SEARCH_HEADER_SHARE_MODAL: {
            return Object.assign(Object.assign({}, state), { isHeaderShareModalClosed: true });
        }
        default: {
            return state;
        }
    }
};
